var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBathsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 22.5C6.24632 22.5 6.75 21.9963 6.75 21.375C6.75 20.7537 6.24632 20.25 5.625 20.25C5.00368 20.25 4.5 20.7537 4.5 21.375C4.5 21.9963 5.00368 22.5 5.625 22.5Z",
    fill: "#2A3842"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 19.875C8.87132 19.875 9.375 19.3713 9.375 18.75C9.375 18.1287 8.87132 17.625 8.25 17.625C7.62868 17.625 7.125 18.1287 7.125 18.75C7.125 19.3713 7.62868 19.875 8.25 19.875Z",
    fill: "#2A3842"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 19.5C3.24632 19.5 3.75 18.9963 3.75 18.375C3.75 17.7537 3.24632 17.25 2.625 17.25C2.00368 17.25 1.5 17.7537 1.5 18.375C1.5 18.9963 2.00368 19.5 2.625 19.5Z",
    fill: "#2A3842"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16.875C5.87132 16.875 6.375 16.3713 6.375 15.75C6.375 15.1287 5.87132 14.625 5.25 14.625C4.62868 14.625 4.125 15.1287 4.125 15.75C4.125 16.3713 4.62868 16.875 5.25 16.875Z",
    fill: "#2A3842"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2501 3.75H20.5595C20.4621 3.74966 20.3656 3.76853 20.2755 3.80553C20.1854 3.84253 20.1035 3.89694 20.0345 3.96563L17.2501 6.75L5.18445 8.75626C5.04786 8.77886 4.92019 8.83882 4.81558 8.92952C4.71098 9.02021 4.63352 9.13809 4.59178 9.27009C4.55004 9.4021 4.54566 9.54309 4.57911 9.67743C4.61257 9.81178 4.68256 9.93424 4.78133 10.0313L13.9688 19.2188C14.0658 19.3175 14.1883 19.3875 14.3227 19.421C14.457 19.4544 14.598 19.45 14.73 19.4083C14.862 19.3666 14.9799 19.2891 15.0706 19.1845C15.1613 19.0799 15.2212 18.9522 15.2438 18.8156L17.2501 6.75",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathsIcon);
export default __webpack_public_path__ + "static/media/bathsIcon.80c9f3d4a551e41fba7f15c8d78cf365.svg";
export { ForwardRef as ReactComponent };